import React, {useMemo} from 'react';
import {useSelector, shallowEqual} from 'react-redux';
import PropTypes from 'prop-types';

import historyComponent from '../hoc/historyComponent';
import utilities from '../../utilities/utilities';

const propTypes = {
  className: PropTypes.string,
  url: PropTypes.string,
  text: PropTypes.string,
  urlType: PropTypes.string,
  doc: PropTypes.string.isRequired,
};

function LoginLink(props) {
  // Props.
  const {
    urlType = 'login', className = 'btn', text = 'Login', doc, url = '',
  } = props;

  // Get redux states.
  const {
    checkedLayers, mapFormData, enabledLeftOverlay, propertyPopupData, activeTab,
  } = useSelector(state => ({
    checkedLayers: state.map.layers.checkedLayers,
    mapFormData: state.map.mapFormData,
    enabledLeftOverlay: state.ui.enabledLeftOverlay,
    propertyPopupData: state.map.propertyPopupData,
    activeTab: state.ui.activeTab,
  }), shallowEqual);

  const placeName = useMemo(
    () =>
      doc
        .split('/')
        .filter(el => el.length)
        .join('-'),
    [doc],
  );

  const onClick = (e) => {
    e.preventDefault();
    sessionStorage.setItem(
      `${placeName}_storage`,
      JSON.stringify({
        enabledLeftOverlay,
        checkedLayers,
        mapFormData,
        propertyPopupData,
        activeTab,
      }),
    );
    window.location.assign(utilities.getDestinationUrl(urlType, url));
  };

  return (
    <a onClick={onClick} href={utilities.getDestinationUrl(urlType, url)} className={className}>
      {text}
    </a>
  );
}

LoginLink.propTypes = propTypes;

export default historyComponent(LoginLink);
